import * as React from 'react';
import { observer } from 'mobx-react-lite';
import { Form } from 'antd';
import { BasicComparisonNodeModel } from '../../models';
import { useNodeComparisonForm } from '../../hooks';
import { ContractComparisonPanelsRenderer } from '..';
import './BasicComparisonRenderer.less';

interface Props {
    comparisonNode: BasicComparisonNodeModel;
}

const BasicComparisonRenderer: React.FC<Props> = ({ comparisonNode }) => {
    const { form, formKey, onValuesChange } = useNodeComparisonForm(
        comparisonNode.newNode,
        comparisonNode.previousNode
    );

    return (
        <div className="basic-comparison-renderer">
            <Form id={comparisonNode.nodeId} key={formKey} form={form} onValuesChange={onValuesChange}>
                <div className="basic-comparison-panels-container">
                    <ContractComparisonPanelsRenderer comparisonNode={comparisonNode} />
                </div>
            </Form>
        </div>
    );
};

export default observer(BasicComparisonRenderer);
